module.exports = __webpack_public_path__ + "img/微信1.57b0a4d.png";